// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle6 from "../../randing/RandingStyle6";

function Randing005({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle6
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/005/01_241107_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/005/01_241107_02.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/005/01_241119_04.jpg`} // 스텝 변경되는 이미지
      questionContainer="1"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/005/01_241107_btn_send.png`}
      companyName="청춘플란트치과의원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/005/241107_footer.jpg`}
    />
  );
}

export default Randing005;
